import Delete from '@img/icons/close.svg';
import SvgEdit from '@img/icons/edit.svg';
import Button from '@stories/Components/Buttons/Button/Button';
import Dropdown from '@stories/Components/Inputs/Dropdown/Dropdown';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { BookEventFormStyles } from '../../BookEventForm.styles';
import { StepOneStyles as S } from './StepOne.styles';
const StepOne = ({ stepProps, activeStep, step, setActive, submit, response, }) => {
    const [selectedTicket, setSelectedTicket] = React.useState();
    const [ticketTypes, setTicketTypes] = React.useState([]);
    const [attendeesMapping, setAttendeesMapping] = React.useState({});
    const isValidState = React.useMemo(() => Object.keys(attendeesMapping).reduce((acc, cur) => {
        const curNumber = Number(attendeesMapping[cur]);
        if (!isNaN(curNumber) && curNumber >= 0) {
            acc += curNumber;
        }
        return acc;
    }, 0) > 0, [attendeesMapping]);
    const handleSelectedTicketChange = (e) => {
        setSelectedTicket(e.currentTarget.value);
        const existingType = ticketTypes.find((x) => x.ticketId === e.currentTarget.value);
        if (!existingType) {
            const matchingTicket = stepProps.tickets.find((x) => x.ticketId === e.currentTarget.value);
            if (matchingTicket) {
                const clone = [...ticketTypes];
                clone.push(matchingTicket);
                // Also initialise a new entry in the attendees mapping //
                const attendeesClone = { ...attendeesMapping };
                attendeesClone[matchingTicket.ticketId] = 1;
                setAttendeesMapping(attendeesClone);
                setTicketTypes(clone);
            }
        }
    };
    const handleAttendeeQuantityUpdate = (key, e) => {
        const value = e.currentTarget.value;
        const valueNumber = Number(value);
        if ((!isNaN(valueNumber) && valueNumber >= 0) || value === '') {
            const entryIndex = Object.keys(attendeesMapping).indexOf(key);
            if (entryIndex > -1) {
                const clone = { ...attendeesMapping };
                clone[key] = isNaN(valueNumber) ? valueNumber : value;
                setAttendeesMapping(clone);
            }
        }
    };
    const deleteAttendeeQuantity = (key) => {
        const clone = { ...attendeesMapping };
        delete clone[key];
        setAttendeesMapping(clone);
        const existingType = ticketTypes.find((x) => x.ticketId === key);
        if (existingType) {
            const typeIndex = ticketTypes.indexOf(existingType);
            if (typeIndex > -1) {
                const typesClone = [...ticketTypes];
                typesClone.splice(typeIndex, 1);
                setTicketTypes(typesClone);
            }
        }
    };
    React.useEffect(() => {
        if (response?.data && ticketTypes.length === 0) {
            const newMapping = {};
            response.data.priceData.forEach((x) => {
                newMapping[x.ticketId] = x.quantity;
            });
            setAttendeesMapping(newMapping);
            const clone = [...ticketTypes];
            response.data.priceData.forEach((pd) => {
                const matchingTicket = stepProps.tickets.find((x) => x.ticketId === pd.ticketId);
                if (matchingTicket) {
                    clone.push(matchingTicket);
                }
            });
            setTicketTypes(clone);
        }
    }, [response]);
    const [error, setGeneralError] = React.useState('');
    React.useEffect(() => {
        if (response?.validationErrors) {
            const errors = response.validationErrors;
            if (errors) {
                errors.forEach((err) => {
                    if (err) {
                        if (err.errorTypeName === 'GeneralError') {
                            setGeneralError(err.errorMessage ?? "");
                        }
                    }
                });
                return;
            }
        }
        setGeneralError('');
    }, [response]);
    return (React.createElement(S.Container, null,
        React.createElement(BookEventFormStyles.FormStepTitle, { disabled: activeStep <= step || stepProps.success, onClick: () => setActive(step === activeStep ? 0 : step) },
            React.createElement("span", null,
                "1. ",
                stepProps.title),
            activeStep > step && !stepProps.success && (React.createElement(React.Fragment, null,
                React.createElement("span", null, "Edit"),
                React.createElement(SvgEdit, null)))),
        React.createElement(BookEventFormStyles.FormContent, { isActive: step === activeStep },
            React.createElement(BookEventFormStyles.FormContentInner, null,
                error && React.createElement(BookEventFormStyles.FormError, null, error),
                React.createElement(S.Description, null, stepProps.description),
                React.createElement(S.DropdownWrapper, null,
                    React.createElement("span", null, "Ticket Type*"),
                    React.createElement(Dropdown, { "data-has-value": !!selectedTicket, value: selectedTicket, onChange: (e) => handleSelectedTicketChange(e) },
                        React.createElement("option", { value: "" }, "Select from dropdown"),
                        stepProps.tickets.map((ticket, i) => (React.createElement("option", { key: `StepOne_Ticket_${i}`, value: ticket.ticketId },
                            ticket.ticketName,
                            " - ",
                            ticket.ticketPriceFormatted))))),
                React.createElement(S.AttendeesList, { "data-has-value": Object.keys(attendeesMapping).length > 0 },
                    React.createElement(AnimatePresence, null, ticketTypes.map((type, i) => (React.createElement(S.AttendeeInfo, { key: `StepOne_Attendees_${i}` },
                        React.createElement(Delete, { onClick: () => confirm('Are you sure you want to delete this entry?') &&
                                deleteAttendeeQuantity(type.ticketId) }),
                        React.createElement(S.AttendeeQuantity, { type: "text", onChange: (e) => handleAttendeeQuantityUpdate(type.ticketId, e), value: attendeesMapping[type.ticketId] }),
                        React.createElement("span", null,
                            type.ticketName,
                            ' ',
                            React.createElement("span", { "data-ticket-price": "true" },
                                "(",
                                type.ticketPriceFormatted,
                                " each)")))))))),
            React.createElement(BookEventFormStyles.StepBottom, null,
                React.createElement(Button, { disabled: !isValidState, buttonType: "orange-solid", onClick: () => submit({
                        attendees: attendeesMapping,
                    }) }, "Continue"))),
        response && (React.createElement(BookEventFormStyles.FormContent, { isActive: step !== activeStep },
            React.createElement(BookEventFormStyles.FormContentInner, null, response?.data && (React.createElement(S.SummaryList, null, response.data.priceData.map((data, i) => (React.createElement(S.SummaryItem, { key: `StepOne_Summary_${i}` },
                React.createElement(S.SummaryQuantity, null, data.quantity),
                React.createElement("span", null, data.title),
                React.createElement(S.SummaryPrice, null,
                    "Total Cost:",
                    ' ',
                    React.createElement("span", { "data-discounted": !!data.discountedPriceString }, data.priceString),
                    data.discountedPriceString && (React.createElement(React.Fragment, null,
                        ' ',
                        React.createElement("span", null, data.discountedPriceString))))))))))))));
};
export default StepOne;
